import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface CommentsButtonProps {
  postId: string;
  postType?: 'training' | 'competition' | 'beltPromotion' | 'post';
  commentCount?: number;
  className?: string;
  iconOnly?: boolean;
}

/**
 * CommentsButton Component
 * 
 * @description A button that navigates to the comments page for a specific post
 */
const CommentsButton: React.FC<CommentsButtonProps> = ({
  postId,
  postType = 'training',
  commentCount = 0,
  className = '',
  iconOnly = false
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    navigate(`/comments/${postType}/${postId}`);
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center justify-center px-4 py-3 min-h-[44px] bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors ${className}`}
      aria-label={t('common.screenNames.comments') as string}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z"
          clipRule="evenodd"
        />
      </svg>
      {!iconOnly && (
        <span className="ml-2">
          {commentCount > 0 ? `${t('glossary.comment_plural') as string} (${commentCount})` : t('glossary.comment_plural') as string}
        </span>
      )}
    </button>
  );
};

export default CommentsButton;